import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Globe, X } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const messages = {
  en: "Showing this site in English based on your browser.",
  fr: "Site affiché en français d'après votre navigateur.",
  es: "Mostrando el sitio en español según tu navegador.",
  de: "Diese Seite wird auf Deutsch angezeigt, basierend auf deinem Browser.",
};

export function AutoDetectNotice() {
  const { lang, autoDetected, dismissAutoNotice } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (autoDetected) {
      const show = setTimeout(() => setVisible(true), 2200);
      const hide = setTimeout(() => setVisible(false), 9000);
      return () => {
        clearTimeout(show);
        clearTimeout(hide);
      };
    }
  }, [autoDetected]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="auto-detect-notice"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-6 left-6 z-[60] flex max-w-sm items-center gap-3 rounded-md border border-clan-ink/10 bg-clan-bg/90 py-3 pl-4 pr-3 backdrop-blur-xl"
        >
          <Globe className="h-4 w-4 shrink-0 text-clan-accent" />
          <p className="text-sm text-clan-ink">{messages[lang] || messages.en}</p>
          <button
            data-testid="auto-detect-dismiss"
            onClick={() => {
              setVisible(false);
              dismissAutoNotice();
            }}
            className="grid h-6 w-6 shrink-0 place-items-center rounded-md text-clan-muted transition-colors hover:bg-clan-ink/[0.06] hover:text-clan-ink"
            aria-label="Dismiss"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
